var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.infoShow === true)?_c('div',{staticClass:"info wrap"},[_c('div',{staticClass:"info-cover"},[_c('div',{staticClass:"info-box"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }